
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3.515 2.455a.75.75 0 00-1.03 1.09l3.194 3.017a17.043 17.043 0 00-4.334 5.073.75.75 0 00-.01.71L2 12l-.665.346v.001l.001.002.003.006.01.018a7.285 7.285 0 00.172.306 18.069 18.069 0 002.555 3.344C5.848 17.842 8.53 19.75 12 19.75h.012a10.142 10.142 0 005.682-1.84l2.791 2.635a.75.75 0 001.03-1.09l-18-17zm16.46 11.236l-8.239-7.937c.088-.003.175-.004.262-.004H12c2.893 0 5.211 1.592 6.85 3.273a16.56 16.56 0 012.287 2.975 15.391 15.391 0 01-1.162 1.693zm2.69-2.037L22 12l.665-.346v-.001l-.001-.002-.003-.006-.01-.018a15.887 15.887 0 00-.696-1.138 18.063 18.063 0 00-2.031-2.512C18.152 6.158 15.47 4.25 12 4.25H12V5l.002-.75H12a9.35 9.35 0 00-2.075.228.75.75 0 00-.355 1.272l9.945 9.581a.75.75 0 001.085-.046 16.913 16.913 0 002.055-2.92.75.75 0 00.01-.71zM3.29 12.676c-.18-.27-.323-.5-.426-.673a15.563 15.563 0 013.68-4.213l2.496 2.402a3.292 3.292 0 00-.328 3.147c.177.422.44.804.771 1.123.332.319.725.569 1.156.736a3.573 3.573 0 003.248-.341l2.316 2.229a8.67 8.67 0 01-4.209 1.164c-2.89-.002-5.207-1.593-6.843-3.273a16.569 16.569 0 01-1.86-2.301zm6.831-1.364l.027-.054 2.609 2.511-.01.005a2.07 2.07 0 01-1.565.026 1.989 1.989 0 01-.658-.419 1.87 1.87 0 01-.43-.623 1.788 1.788 0 01.027-1.446z","fill":"currentColor"}})])
          )
        }
      }
    